<template>
  <div class="controls-wrapper">
    <span class="control save" title="Сохранить пресет" @click="createPreset">
      <UiBaseIcon icon-name="save" width="14px" height="14px" color="#989898" />
    </span>
    <span class="control bolt" title="Применить пресет" @click="loadList">
      <UiBaseIcon icon-name="bolt" width="14px" height="14px" color="#989898" />
    </span>

    <create v-if="isShownCreate" :show.sync="isShownCreate" />
    <list v-if="isShownLoad" :show.sync="isShownLoad" />
  </div>
</template>

<script>
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

export default {
  components: {
    create: () => import('./create.vue'),
    list: () => import('./list.vue'),
    UiBaseIcon,
  },
  data() {
    return {
      isShownCreate: false,
      isShownLoad: false,
    }
  },
  methods: {
    createPreset() {
      this.isShownCreate = true
    },
    loadList() {
      this.isShownLoad = true
    },
  },
}
</script>

<style lang="scss" scoped>
.controls-wrapper {
  padding: 3px 0;
  border: 1px solid $color-gray-50;

  @include border_radius(5px);
  @include createFlex(flexbox, nowrap, row, flex-start, stretch, stretch);

  >>> .control {
    cursor: pointer;

    &.save {
      padding: 0 rem(10px) 0 rem(15px);

      &:hover {
        path {
          fill: $primary;
        }
      }
    }

    &.bolt {
      padding: 0 rem(10px);
      &:hover {
        path {
          fill: $yellow;
        }
      }
    }
  }
}
</style>
